<!-- src/ColorVariantOption.vue -->
<script>
  import { productStore } from '@/lib/productStore';
  import { cleanName, handleize, isTrimmed, buildSizedImageUrl, buildResponsiveSrcset, reportProductSwatchSwitch, normalizeShopifyProductId } from '@/lib/vue-helpers.js';
  import { fetchSizeGuidePageContent } from '@/lib/sizeGuide.js';
  import { syncPdpFavoriteProduct } from '@/lib/pdpFavorites.js';
  import { emitter } from '@/main';
  import PDPPriceGroupBlock from '@/PDPPriceGroupBlock.vue';
  import storefront from '@/lib/storefront';
  import * as queries from '@/lib/queries';

  export default {
    name: 'ColorVariantOption',
    props: {
      previouslySelectedProduct: {
        type: Object,
        default: null
      }
    },
    components: {
      PDPPriceGroupBlock
    },
    computed: {
      cleanColorName() {
        return name => cleanName(name);
      },
      bundleSelectorLabel() {
        if (this.bundleOptionTitle && this.bundleOptionTitle.trim().length) {
          return this.bundleOptionTitle;
        }
        return 'Bundle Options';
      },
      swatchRenderingConfig() {
        return {
          showColorSwatches: !this.swatch_suffix || this.isCurrentExcludedColorOption(),
          showImageSwatches: this.swatch_suffix && !this.isCurrentExcludedColorOption(),
          shouldShowSwatches: !this.swatch_suffix || this.isCurrentExcludedColorOption() || (this.swatch_suffix && !this.isCurrentExcludedColorOption())
        };
      },
      bundleSizeGuideAnchorKey() {
        if (!this.showSizeGuideButton || !Array.isArray(this.bundleChildren)) {
          return null;
        }
        const child = this.bundleChildren.find(bundleChild => this.childHasSizeOption(bundleChild));
        return child ? child.key : null;
      }
    },
    data() {
      return {
        colorPriceGroupMap: null,
        colorTagPrefix: 'color-',
        colors: [],
        currentBling: '',
        current_product_type: '',
        customBling: '',
        customBlingBase: '',
        customBlingElements: [],
        enablePriceGrouping: false,
        excludedProductType: [],
        hasUpsellProduct: false,
        imageKey: null,
        imageNS: null,
        includedProductType: '',
        isColorSelected: false,
        isLoading: false,
        mini_pdp: false,
        isOutfitPicker: false,
        outfitPickerIndex: null,
        pdpSection: null,
        optionOneName: '',
        passedOptOne: '',
        priceGroupOrder: false,
        priceGroups: [],
        priceGroupsCompareList: [],
        productCollection: '',
        product_handle: '',
        product_swatch_name: '',
        product_title: '',
        enableLazyLoading: typeof window !== 'undefined' && window.theme && window.theme.settings ? Boolean(window.theme.settings.enable_lazy_loading) : true,
        selectedColor: '',
        selectedSize: '',
        selectedWidth: '',
        showPercentageOff: false,
        showOriginalOnSalePrice: true,
        swatchColorGroupOrder: [],
        swatch_suffix: '',
        upsellProductDetails: window.product_upsell_options_option_product || null,
        variants: [],
        upsellProductDetails2: window.product_upsell_options_option_product_2 || null,
        imageNS2: null,
        imageKey2: null,
        vimageNS: null,
        vimageKey: null,
        variant_image_metafield_name: null,
        enableABTestingVariable: null,
        comingSoonTag: window.siteGlobals.set_reminder_tag,
        previousVariant: null,
        abTestingHandler: null,
        pendingProductColor: null,
        bundleSwatchMetafieldNameSpace: null,
        bundleSwatchMetafieldName: null,
        isBundleFromDom: false,
        bundleOptionTitle: '',
        bundleOptionOrder: [],
        optionTwoOrderTokens: [],
        optionThreeOrderTokens: [],
        isBundleProduct: false,
        bundleFamilies: [],
        bundledProducts: [],
        activeBundleHandle: null,
        activeBundleIndex: 0,
        bundleChildren: [],
        bundleChildSelections: {},
        activeBundleVariantId: null,
        suspendBundleChildSync: false,
        defaultsTimer: null,
        sizeGuideMetafield: '',
        showSizeGuideButton: false,
        bundleSizeGuideLoading: false,
        lastEmittedHandle: '',
        sourceProductID: '',
        currentDisplayedProductID: ''
      };
    },
    mounted() {
      this.showPercentageOff = this.$el.parentElement.getAttribute('data-showPercentageOff');
      this.sourceProductID = this.$el.parentElement.getAttribute('data-product-id') || '';
      this.currentDisplayedProductID = this.sourceProductID;

      if (this.upsellProductDetails) {
        this.imageNS = this.upsellProductDetails.split('.')[0];
        this.imageKey = this.upsellProductDetails.split('.')[1];
      }

      if (this.upsellProductDetails2) {
        this.imageNS2 = this.upsellProductDetails2.split('.')[0];
        this.imageKey2 = this.upsellProductDetails2.split('.')[1];
      }

      this.variant_image_metafield_name = this.$el.parentElement.getAttribute('data-variant_image_metafield_name');
      if (this.variant_image_metafield_name) {
        this.vimageNS = this.variant_image_metafield_name.split('.')[0];
        this.vimageKey = this.variant_image_metafield_name.split('.')[1];
      }

      this.product_title = this.$el.parentElement.getAttribute('data-product-name');
      this.product_handle = this.$el.parentElement.getAttribute('data-product-handle');
      this.imageLookUpMax = parseInt(this.$el.parentElement.getAttribute('data-imageLookUpMax'));
      this.swatchColorGroupOrder = this.$el.parentElement.getAttribute('data-swatchColorGroupOrder')?.split(',') || [];
      this.swatch_suffix = this.$el.parentElement.getAttribute('data-swatch_suffix');
      this.current_product_type = this.$el.parentElement.getAttribute('data-current_product_type');
      this.excludedProductType = this.$el.parentElement.getAttribute('data-excludedProductType').split(',');
      this.mini_pdp = this.$el.parentElement.getAttribute('data-mini-pdp') === 'true';
      this.isOutfitPicker = this.$el.parentElement.getAttribute('data-is-outfit-picker') === 'true';
      const rawOutfitIdx = this.$el.parentElement.getAttribute('data-outfit-picker-index');
      this.outfitPickerIndex = rawOutfitIdx !== null && rawOutfitIdx !== '' ? Number(rawOutfitIdx) : null;
      this.pdpSection = this.$el.parentElement.closest('.product-single') || this.$el.parentElement.closest('.mini-product-single');
      this.product_swatch_name = this.$el.parentElement.getAttribute('data-product-swatch-name');
      this.customBling = this.$el.parentElement.getAttribute('data-customBling');
      this.customBlingElements = this.$el.parentElement.getAttribute('data-customBlingElements').split(',');
      this.priceGroupOrder = this.$el.parentElement.getAttribute('data-priceGroupOrder');
      this.enablePriceGrouping = this.$el.parentElement.getAttribute('data-enablePriceGrouping');
      this.showOriginalOnSalePrice = this.$el.parentElement.getAttribute('data-showOriginalOnSalePrice') === 'true';
      this.productCollection = this.$el.parentElement.getAttribute('data-product-collection');
      this.excludeSwatchWidth = window.excludeSwatchWidth === 'true';
      this.isBundleFromDom = this.$el.parentElement.getAttribute('data-is-bundle') === 'true';
      this.bundleOptionTitle = this.$el.parentElement.getAttribute('data-bundle-option-title') || '';
      const bundleSwatchMetafieldAttr = this.$el.parentElement.getAttribute('data-bundle-swatch-metafield-name');
      if (bundleSwatchMetafieldAttr && bundleSwatchMetafieldAttr.includes('.')) {
        const [namespace, key] = bundleSwatchMetafieldAttr.split('.');
        this.bundleSwatchMetafieldNameSpace = namespace || null;
        this.bundleSwatchMetafieldName = key || null;
      }
      this.refreshBundleOptionOrder();
      this.sizeGuideMetafield = window.sizeGuideMetafield || '';
      this.optionTwoOrderTokens = this.normalizeOrderTokens((typeof window !== 'undefined' && (window.defaultOptionOrder || window.siteGlobals?.defaultOptionOrder)) || '');
      this.optionThreeOrderTokens = this.normalizeOrderTokens((typeof window !== 'undefined' && (window.optionthreeorder || window.siteGlobals?.optionthreeorder)) || '');

      if (this.isOutfitPicker) {
        this.pdpSection = this.$el.parentElement;
      }

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      this.passedOptOne = urlParams.get('op1');

      emitter.on('product-data-updated', this.handleProductData);
      emitter.on('plytix-product-data-ready', this.handlePlytixData);
      emitter.on('ctl-request-bundle-children', this.emitBundleChildrenMetaUpdate);
      emitter.on('variant-size-selected', ({ size }) => {
        if (this.isOutfitPicker) return;
        if (this.variants.length && !this.variants.some(v => v.size === size)) return;
        this.selectedSize = size;
        this.updateColorPriceGroupMapping();
        this.setAddToBagButton();
      });
      emitter.on('variant-width-selected', ({ width }) => {
        if (this.isOutfitPicker) return;
        if (this.variants.length && !this.variants.some(v => v.width === width)) return;
        this.selectedWidth = width;
        this.setAddToBagButton();
      });

      if (this.isOutfitPicker) {
        this.outfitPickerIndex = Number(this.$el.parentElement.getAttribute('data-outfit-picker-index')) || 0;
        this.onOutfitPickerProductChanged = ({ blockIndex, productColor }) => {
          if (blockIndex === this.outfitPickerIndex && productColor) {
            this.pendingProductColor = productColor;
            this.selectedColor = productColor;
            this.isColorSelected = true;
          }
        };
        emitter.on('outfit-picker-product-changed', this.onOutfitPickerProductChanged);
      }

      const hasPlytixData = this.checkPlytixData();
      if (!hasPlytixData) {
        this.initializeData();
      }
      this.setBlingLinks();

      this.enableABTestingVariable = this.$el.parentElement.getAttribute('data-enableABTestingVariable')?.toString() || null;
      if (window[this.enableABTestingVariable]) {
        this.enablePriceGrouping = window[this.enableABTestingVariable].toString();
      }

      if (this.enableABTestingVariable !== null) {
        this.abTestingHandler = event => {
          const testCase = event.detail.toString();
          if (testCase !== this.enablePriceGrouping) {
            this.enablePriceGrouping = testCase;
          }
        };
        window.addEventListener(this.enableABTestingVariable, this.abTestingHandler);
      }
    },
    beforeUnmount() {
      clearTimeout(this.defaultsTimer);
      emitter.off('product-data-updated', this.handleProductData);
      emitter.off('plytix-product-data-ready', this.handlePlytixData);
      emitter.off('ctl-request-bundle-children', this.emitBundleChildrenMetaUpdate);
      emitter.off('variant-size-selected');
      emitter.off('variant-width-selected');
      if (this.isOutfitPicker && this.onOutfitPickerProductChanged) {
        emitter.off('outfit-picker-product-changed', this.onOutfitPickerProductChanged);
      }
      if (this.enableABTestingVariable !== null && this.abTestingHandler) {
        window.removeEventListener(this.enableABTestingVariable, this.abTestingHandler);
      }
    },
    methods: {
      hasVisibleSwatchesForPriceGroup(priceGroup) {
        if (!this.colorPriceGroupMap) return false;
        // Check if any colors in this price group would be visible
        const colorsInPriceGroup = this.colors.filter(color => this.colorPriceGroupMap.get(color.name) === priceGroup);
        return colorsInPriceGroup.length > 0 && this.shouldShowSwatches();
      },
      shouldShowSwatches() {
        return !this.swatch_suffix || this.isCurrentExcludedColorOption() || (this.swatch_suffix && !this.isCurrentExcludedColorOption());
      },
      analyzePriceGrouping(variants) {
        // Group by size and check if any size has different prices across colors
        const sizePriceMap = new Map();

        variants.forEach(variant => {
          if (variant.size && variant.color) {
            if (!sizePriceMap.has(variant.size)) {
              sizePriceMap.set(variant.size, new Set());
            }
            sizePriceMap.get(variant.size).add(variant.price);
          }
        });

        // Check if any size has multiple prices
        return Array.from(sizePriceMap.values()).some(prices => prices.size > 1);
      },
      setupPriceGrouping(result) {
        // Build price groups from all unique prices
        const allPrices = new Set(result.variants.map(v => v.price));
        this.priceGroups = Array.from(allPrices);

        // Build compare price map
        this.priceGroupsCompareList = {};
        result.variants.forEach(variant => {
          this.priceGroupsCompareList[variant.price] = variant.compareAtPrice || '';
        });

        // Create color price group mapping
        this.colorPriceGroupMap = new Map();
        result.colors.forEach(color => {
          const colorVariants = result.variants.filter(v => v.color === color.name);
          if (colorVariants.length > 0) {
            const targetVariant = this.selectedSize ? colorVariants.find(v => v.size === this.selectedSize) || colorVariants[0] : colorVariants[0];

            this.colorPriceGroupMap.set(color.name, targetVariant.price);
          }
        });
      },
      updateColorPriceGroupMapping() {
        if (this.colorPriceGroupMap && this.enablePriceGrouping === 'true') {
          this.colors.forEach(color => {
            const colorVariants = this.variants.filter(v => v.color === color.name);
            if (colorVariants.length > 0) {
              // Find the variant for the currently selected size, or use the first available
              let targetVariant = colorVariants[0]; // default to first variant

              if (this.selectedSize) {
                const sizeVariant = colorVariants.find(v => v.size === this.selectedSize);
                if (sizeVariant) {
                  targetVariant = sizeVariant;
                }
              }

              this.colorPriceGroupMap.set(color.name, targetVariant.price);
            }
          });
        }
      },
      isComingSoonColor(color) {
        if (color.tags.includes(this.comingSoonTag)) {
          return true;
        }
        return false;
      },
      isExcludedColorOption(pType) {
        if (!this.excludedProductType.includes(pType)) {
          return this.getSwatchClass();
        }
        return 'option p-options option2';
      },
      isCurrentExcludedColorOption() {
        if (this.excludedProductType.includes(this.current_product_type)) {
          return true;
        } else {
          return false;
        }
      },
      getSwatchClass() {
        let swatchClass = 'color-swatches p-options';
        if (this.productImageName != '') {
          swatchClass = 'color-swatches p-options product-image';
        }
        return swatchClass;
      },
      getImageSwatchClass() {
        let swatchClass = 'image-swatches p-options product-image';
        return swatchClass;
      },
      checkPlytixData() {
        if (this.current_product_type && this.current_product_type.trim().toLowerCase() === 'bundles') {
          return false;
        }
        const plytixEnabled = this.pdpSection?.getAttribute('data-plytix-data-enabled') === 'true';
        if (!plytixEnabled) {
          return false;
        }
        const preloadedData = productStore.getPreloadedProductData(this.product_title, this.product_handle);
        if (preloadedData && preloadedData.length > 0) {
          productStore.processAndEmitData(preloadedData, this.product_title, this.product_handle);
          this.handleContentLoaded();
          return true;
        }
        return false;
      },
      handlePlytixData(processedData) {
        if (processedData && Array.isArray(processedData) && processedData.length > 0) {
          const preloadedData = productStore.getPreloadedProductData(this.product_title, this.product_handle);
          if (preloadedData && preloadedData.length > 0) {
            productStore.processAndEmitData(preloadedData, this.product_title, this.product_handle);
            this.handleContentLoaded();
          }
        }
      },
      async initializeData() {
        this.isLoading = true;
        try {
          await productStore.fetchProductData(this.product_title, window.Shopify.country, this.imageLookUpMax, parseInt(window.siteGlobals.pdp_productsByTitleLookup), this.imageNS, this.imageKey, this.imageNS2, this.imageKey2, this.vimageNS, this.vimageKey, this.bundleSwatchMetafieldNameSpace, this.bundleSwatchMetafieldName, this.product_handle);
        } catch (err) {
          console.error('PDP color data fetch failed:', err);
        } finally {
          this.isLoading = false;
          this.handleContentLoaded();
          if (!this.colors || !this.colors.length) {
            this.emitFallbackStartFullPdp();
          }
        }
      },
      emitFallbackStartFullPdp() {
        emitter.emit('start-full-pdp', { images: [], media: [], pid: '', tags: [], handle: this.product_handle });
      },
      handleContentLoaded() {
        const loader = this.$el.parentElement.closest('.pdp-color-variant-options-container').querySelector('.pdp-variant-loader');
        if (loader) {
          loader.style.minHeight = '0';
          loader.style.display = 'none';
        }
      },
      handleProductData(data) {
        if (!data || !data.colors) {
          console.error('Invalid data received in handleProductData:', data);
          return;
        }
        const titleMatches = data.productTitle === this.product_title || handleize(data.productTitle || '') === handleize(this.product_title || '');
        const handleMatches = Boolean(this.product_handle && data.colors.some(color => color.handle === this.product_handle));
        if (!titleMatches && !handleMatches) {
          return;
        }

        this.isBundleProduct = Boolean(data.isBundleProduct);
        this.bundleFamilies = data.bundleFamilies || [];
        this.bundledProducts = data.bundledProducts || [];
        this.activeBundleHandle = data.activeBundleHandle || (this.isBundleProduct && this.bundledProducts.length ? this.bundledProducts[0].handle : this.product_handle);
        if (this.isBundleProduct) {
          this.ensureBundleSizeGuideSetup();
          if (!this.bundleOptionOrder.length) {
            this.refreshBundleOptionOrder();
          }
        } else {
          this.showSizeGuideButton = false;
          this.bundleOptionOrder = [];
        }

        if (this.isBundleProduct && this.bundledProducts.length) {
          const activeIndex = this.bundledProducts.findIndex(bundle => bundle?.handle === this.activeBundleHandle);
          this.activeBundleIndex = activeIndex >= 0 ? activeIndex : 0;
          const activeBundle = this.bundledProducts[this.activeBundleIndex];
          if (activeBundle && this.product_handle !== activeBundle.handle) {
            this.product_handle = activeBundle.handle;
          }
          this.applyBundleProductData(activeBundle || data);
        } else {
          this.activeBundleIndex = 0;
          this.applyBundleProductData(data);
        }
      },
      applyBundleProductData(productData) {
        if (!productData) {
          console.warn('[ColorVariantOption] No product data available for bundle application');
          return;
        }
        this.priceGroups = [];
        this.hasUpsellProduct = Boolean(productData.hasUpsellProduct);

        const processedColors = (productData.colors || []).map(color => {
          let colorGroupId = '';
          for (const tag of color.tags || []) {
            if (tag.startsWith(this.colorTagPrefix)) {
              colorGroupId = tag.trim();
              break;
            }
          }

          if (color.price && !this.priceGroups.includes(color.price)) {
            this.priceGroups.push(color.price);
          }

          return {
            ...color,
            colorGroupId
          };
        });

        (productData.variants || []).forEach(variant => {
          if (variant.price && !this.priceGroups.includes(variant.price)) {
            this.priceGroups.push(variant.price);
          }
        });

        this.colors = this.sortColorGroupOrder(processedColors);
        this.optionOneName = productData.optionOneName || this.optionOneName;
        this.variants = productData.variants || [];
        this.bundleChildren = this.buildBundleChildren(productData);
        this.bundleChildSelections = this.buildInitialBundleChildSelections(this.bundleChildren);
        this.activeBundleVariantId = null;
        if (this.isBundleProduct) {
          this.emitBundleChildHandleUpdate();
          this.emitBundleChildrenMetaUpdate();
        }

        const needsPriceGrouping = this.analyzePriceGrouping(productData.variants);
        if (needsPriceGrouping) {
          this.setupPriceGrouping({
            colors: this.colors,
            variants: productData.variants
          });
        } else {
          this.enablePriceGrouping = 'false';
        }

        this.handleContentLoaded();

        const sortPriceGroups = this.priceGroups.sort((a, b) => b - a);
        this.priceGroups = this.priceGroupOrder === 'false' ? sortPriceGroups : sortPriceGroups.reverse();

        if (this.previouslySelectedProduct) {
          const selectedColor = this.colors.find(c => c.name === this.previouslySelectedProduct.color);
          if (selectedColor && selectedColor.images) {
            this.setColorSelection(this.previouslySelectedProduct.name, selectedColor.images, selectedColor.media, selectedColor.tags, selectedColor.pid, this.previouslySelectedProduct.handle, selectedColor.description);
          }
        }

        if (this.pendingProductColor) {
          this.applyPendingProductColor();
        }

        clearTimeout(this.defaultsTimer);
        this.defaultsTimer = setTimeout(() => this.setDefaultSelections(), 300);
        this.emitBundleHandleUpdate(this.product_handle);
      },
      selectBundle(handle) {
        if (!this.isBundleProduct || !handle) {
          return;
        }
        const index = this.bundledProducts.findIndex(bundle => bundle?.handle === handle);
        if (index === -1 || index === this.activeBundleIndex) {
          return;
        }
        const selectedBundle = this.bundledProducts[index];
        const nextProductID = this.getBundleProductId(selectedBundle);
        if (nextProductID) {
          if (!this.sourceProductID) {
            this.sourceProductID = nextProductID;
          }
          if (this.sourceProductID && nextProductID !== String(this.sourceProductID) && nextProductID !== String(this.currentDisplayedProductID)) {
            reportProductSwatchSwitch({ productID: nextProductID, sourceProductID: this.sourceProductID });
          }
          this.currentDisplayedProductID = nextProductID;
        }
        this.activeBundleIndex = index;
        this.activeBundleHandle = handle;
        this.product_handle = handle;
        this.applyBundleProductData(selectedBundle);
        this.emitBundleHandleUpdate();
        this.emitBundleChildHandleUpdate();
        this.emitBundleChildrenMetaUpdate();
        emitter.emit('bundled-product-selected', {
          handle,
          index,
          bundle: selectedBundle
        });
      },
      getBundleProductId(bundle) {
        if (!bundle) return '';
        return normalizeShopifyProductId(bundle.id) || normalizeShopifyProductId(bundle.pid) || '';
      },
      emitBundleChildrenMetaUpdate() {
        if (!this.isBundleProduct || !Array.isArray(this.bundleChildren)) {
          return;
        }
        const children = this.bundleChildren
          .filter(child => child && child.handle)
          .map(child => ({
            handle: child.handle,
            title: child.title || ''
          }));
        emitter.emit('bundle-children-meta-updated', {
          isBundleProduct: Boolean(this.isBundleProduct),
          children
        });
      },
      getBundleSwatchStyle(bundle) {
        const url = bundle?.bundleSwatchImageUrl ? this.buildSizedImageUrl(bundle.bundleSwatchImageUrl, 120) : '';
        return url ? { backgroundImage: `url(${url})` } : {};
      },
      buildBundleChildren(productData) {
        const childMap = new Map();
        const variants = productData?.variants || [];
        const bundleComponents = productData?.bundleComponents || {};
        const bundleChildSwatches = productData?.bundleChildSwatches || {};

        variants.forEach(variant => {
          const components = bundleComponents[variant.variantId] || [];
          const swatchMapForVariant = bundleChildSwatches[variant.variantId] || {};
          components.forEach((component, index) => {
            const key = this.getBundleChildKey(component, index);
            if (!childMap.has(key)) {
              childMap.set(key, {
                key,
                title: component.productTitle || `Product ${childMap.size + 1}`,
                handle: component.productHandle || '',
                productId: component.productId || '',
                optionsMap: {},
                image: component.image || '',
                swatchColor: component.swatchColor || component.color || ''
              });
            }
            const child = childMap.get(key);
            if (!child.image && component.image) {
              child.image = component.image;
            }
            if (!child.swatchColor && (component.swatchColor || component.color)) {
              child.swatchColor = component.swatchColor || component.color;
            }
            if (!child.productId && component.productId) {
              child.productId = component.productId;
            }
            if (!child.swatchColor) {
              const swatchEntry = swatchMapForVariant[key];
              if (swatchEntry?.color) {
                child.swatchColor = swatchEntry.color;
              }
            }
            (component.selectedOptions || []).forEach(option => {
              if (!option?.name || !option?.value) {
                return;
              }
              if (!child.optionsMap[option.name]) {
                child.optionsMap[option.name] = new Set();
              }
              child.optionsMap[option.name].add(option.value);
            });
          });
        });

        return Array.from(childMap.values()).map(child => {
          const options = Object.entries(child.optionsMap).map(([name, values]) => ({
            name,
            values: this.sortBundleOptionValues(name, Array.from(values))
          }));
          const visibleOptions = options.filter(option => this.shouldShowBundleOption(option));
          const hasSizeOption = visibleOptions.some(option => this.isSizeOptionName(option.name));

          return {
            key: child.key,
            title: child.title,
            handle: child.handle,
            productId: child.productId || '',
            image: child.image,
            swatchColor: child.swatchColor,
            options,
            visibleOptions,
            hasSizeOption
          };
        });
      },
      ensureBundleSizeGuideSetup() {
        if (!this.isBundleProduct) {
          return;
        }
        if (!this.sizeGuideMetafield) {
          this.sizeGuideMetafield = window.sizeGuideMetafield || '';
        }
        if (!this.sizeGuideMetafield || !this.sizeGuideMetafield.includes('.')) {
          return;
        }
        if (this.showSizeGuideButton || this.bundleSizeGuideLoading) {
          return;
        }
        this.loadSizeGuideContent();
      },
      async loadSizeGuideContent() {
        if (this.bundleSizeGuideLoading) {
          return;
        }
        this.bundleSizeGuideLoading = true;
        let shouldShowButton = false;
        try {
          const [namespace, key] = this.sizeGuideMetafield.split('.');
          const metafields = await this.getMetafields([{ namespace, key }]);
          if (!metafields || !metafields.length) {
            return;
          }
          const sizeGuideMetafield = metafields.find(m => m?.key === key);
          if (!sizeGuideMetafield?.value) {
            return;
          }
          const pageId = sizeGuideMetafield.value.split('/').pop();
          const pageData = await fetchSizeGuidePageContent(pageId);
          if (!pageData) {
            return;
          }
          const modalIndex = this.getSizeGuideModalIndex();
          const container = document.querySelector(`.size-guide-content-${modalIndex}`);
          if (container) {
            container.innerHTML = pageData.content;
            document.dispatchEvent(new CustomEvent('theme:rte:bind', { detail: { root: container } }));
            shouldShowButton = true;
          }
        } catch (error) {
          console.error('[ColorVariantOption] Error loading size guide data', error);
        } finally {
          this.showSizeGuideButton = shouldShowButton;
          this.bundleSizeGuideLoading = false;
        }
      },
      async getMetafields(metaIdentifier) {
        try {
          const response = await storefront.request(queries.metafieldsByProductHandle, {
            variables: {
              handle: this.product_handle,
              countryIso2: window.Shopify.country,
              metaIdentifier
            }
          });
          return response?.data?.product?.metafields || null;
        } catch (error) {
          console.error('Error fetching size guide metafields', error);
          return null;
        }
      },
      getSizeGuideModalIndex() {
        return 1;
      },
      setBundleSizeGuideFloatingContentVisible(shouldShow) {
        document.dispatchEvent(new CustomEvent(shouldShow ? 'chat:show' : 'chat:hide', { bubbles: true }));
      },
      showSizeGuide() {
        const modalId = `sizeGuideModal-${this.getSizeGuideModalIndex()}`;
        if (window.MicroModal && typeof window.MicroModal.show === 'function') {
          try {
            window.MicroModal.show(modalId, {
              disableScroll: true,
              onShow: () => this.setBundleSizeGuideFloatingContentVisible(false),
              onClose: () => this.setBundleSizeGuideFloatingContentVisible(true)
            });
            return;
          } catch (error) {
            console.error('Error showing size guide modal via MicroModal', error);
          }
        }
        const fallback = document.getElementById(modalId) || document.getElementById('sizeGuideModal-1');
        if (!fallback) {
          return;
        }
        fallback.classList.add('is-open');
        document.documentElement.classList.remove('aos-initialized');
        document.body.classList.add('unscrollable-body');
        this.setBundleSizeGuideFloatingContentVisible(false);
      },
      shouldShowBundleSizeGuide(child) {
        if (!this.showSizeGuideButton || !child) {
          return false;
        }
        return this.childHasSizeOption(child);
      },
      childHasSizeOption(child) {
        if (!child) {
          return false;
        }
        if (typeof child.hasSizeOption === 'boolean') {
          return child.hasSizeOption;
        }
        return Array.isArray(child.visibleOptions) && child.visibleOptions.some(option => this.isSizeOptionName(option.name));
      },
      isSizeOptionName(name) {
        if (!name || typeof name !== 'string') {
          return false;
        }
        const normalized = name.toLowerCase();
        const keywords = ['size', 'waist', 'inseam', 'length', 'width'];
        return keywords.some(keyword => normalized.includes(keyword));
      },
      isWidthOptionName(name) {
        if (!name || typeof name !== 'string') {
          return false;
        }
        const normalized = name.toLowerCase();
        const keywords = ['width', 'calf'];
        return keywords.some(keyword => normalized.includes(keyword));
      },
      getBundleChildKey(component, index) {
        if (!component || typeof component !== 'object') {
          return `bundle-child-${index}`;
        }
        return component.productHandle || `${component.productTitle || 'child'}-${index}`;
      },
      cloneBundleSelections() {
        const clone = {};
        Object.entries(this.bundleChildSelections || {}).forEach(([key, optionMap]) => {
          clone[key] = { ...(optionMap || {}) };
        });
        return clone;
      },
      updateBundleChildSelection(childKey, optionName, value) {
        const current = this.bundleChildSelections[childKey] || {};
        this.bundleChildSelections = {
          ...this.bundleChildSelections,
          [childKey]: { ...current, [optionName]: value }
        };
      },
      buildBundleSelectionConstraints(selections) {
        if (!selections) {
          return [];
        }
        const constraints = [];
        Object.entries(selections).forEach(([childKey, optionMap]) => {
          if (!optionMap || typeof optionMap !== 'object') {
            return;
          }
          Object.entries(optionMap).forEach(([optionName, value]) => {
            if (!value) {
              return;
            }
            constraints.push({
              childKey,
              optionName: String(optionName),
              value,
              normalizedValue: String(value).toLowerCase()
            });
          });
        });
        return constraints;
      },
      getComponentOptionValue(component, optionName) {
        if (!component?.selectedOptions || !optionName) {
          return '';
        }
        const normalizedName = optionName.toLowerCase();
        const match = component.selectedOptions.find(option => {
          if (!option?.name) {
            return false;
          }
          return option.name.toLowerCase() === normalizedName;
        });
        return match?.value != null ? String(match.value) : '';
      },
      updateBundleChildSelectionsFromVariant(variant) {
        if (!variant?.bundleSelections) {
          return;
        }
        const updated = { ...this.bundleChildSelections };
        variant.bundleSelections.forEach((component, index) => {
          const key = this.getBundleChildKey(component, index);
          const current = updated[key] || {};
          const patch = {};
          (component.selectedOptions || []).forEach(option => {
            if (option?.name && option?.value) {
              patch[option.name] = option.value;
            }
          });
          updated[key] = { ...current, ...patch };
        });
        this.bundleChildSelections = updated;
      },
      findBundleVariantByColor(colorName) {
        if (!Array.isArray(this.variants) || !colorName) {
          return null;
        }
        const normalizedColor = colorName.toLowerCase();
        const matches = this.variants.filter(variant => (variant.color || '').toLowerCase() === normalizedColor);
        if (!matches.length) {
          return null;
        }
        if (this.selectedSize) {
          const normalizedSize = this.selectedSize.toLowerCase();
          const sizeMatch = matches.find(variant => (variant.size || '').toLowerCase() === normalizedSize);
          if (sizeMatch) {
            return sizeMatch;
          }
        }
        return matches[0] || null;
      },
      findBestBundleVariantForSelections(selections) {
        if (!Array.isArray(this.variants) || !this.variants.length) {
          return null;
        }
        const constraints = this.buildBundleSelectionConstraints(selections);
        if (!constraints.length) {
          return this.variants[0];
        }

        let fallbackVariant = null;
        let fallbackScore = -1;

        for (const variant of this.variants) {
          const components = variant.bundleSelections || [];
          const componentMap = new Map();
          components.forEach((component, index) => {
            componentMap.set(this.getBundleChildKey(component, index), component);
          });

          let matches = 0;
          let mismatch = false;

          for (const constraint of constraints) {
            const component = componentMap.get(constraint.childKey);
            if (!component) {
              mismatch = true;
              break;
            }
            const value = this.getComponentOptionValue(component, constraint.optionName);
            if (!value) {
              mismatch = true;
              break;
            }
            const normalizedVariantValue = String(value).toLowerCase();
            if (normalizedVariantValue !== constraint.normalizedValue) {
              mismatch = true;
              break;
            }
            matches += 1;
          }

          if (!mismatch && matches === constraints.length) {
            return variant;
          }

          if (!mismatch && matches > fallbackScore) {
            fallbackVariant = variant;
            fallbackScore = matches;
          }
        }

        return fallbackVariant || this.variants[0] || null;
      },
      hasBundleVariantForSelections(selections, requireAvailable = false) {
        if (!Array.isArray(this.variants) || !this.variants.length) {
          return false;
        }
        const constraints = this.buildBundleSelectionConstraints(selections);
        if (!constraints.length) {
          return false;
        }
        return this.variants.some(variant => {
          if (requireAvailable && !variant.availableForSale) {
            return false;
          }
          const componentMap = new Map();
          (variant.bundleSelections || []).forEach((component, index) => {
            componentMap.set(this.getBundleChildKey(component, index), component);
          });
          return constraints.every(constraint => {
            const component = componentMap.get(constraint.childKey);
            if (!component) {
              return false;
            }
            const value = this.getComponentOptionValue(component, constraint.optionName);
            if (!value) {
              return false;
            }
            return String(value).toLowerCase() === constraint.normalizedValue;
          });
        });
      },
      isBundleChildOptionAvailable(childKey, optionName, value) {
        if (!this.isBundleProduct || !childKey || !optionName) {
          return true;
        }
        const previewSelections = this.cloneBundleSelections();
        if (!previewSelections[childKey]) {
          previewSelections[childKey] = {};
        }
        previewSelections[childKey][optionName] = value;
        return this.hasBundleVariantForSelections(previewSelections, true);
      },
      getBundleChildPrimaryOptionValue(child) {
        if (!child) {
          return '';
        }
        const selections = this.bundleChildSelections[child.key] || {};
        const prioritizeColorOption = (options = []) => {
          return options.find(option => option?.name && option.name.toLowerCase().includes('color')) || options[0] || null;
        };
        const primaryVisible = prioritizeColorOption(child.visibleOptions || []);
        const primaryAll = prioritizeColorOption(child.options || []);
        const primary = primaryVisible || primaryAll;
        if (!primary) {
          return '';
        }
        return selections[primary.name] || primary.values?.[0] || '';
      },
      getBundleChildSwatchColor(child) {
        if (child?.swatchColor) {
          return child.swatchColor;
        }
        if (child?.options && child.options.length) {
          return child.options[0].values?.[0] || '';
        }
        return '';
      },
      hasBundleChildSwatch(child) {
        return Boolean(this.getBundleChildSwatchColor(child) || child?.image);
      },
      getBundleChildSwatchStyle(child) {
        const colorValue = this.getBundleChildSwatchColor(child);
        if (colorValue && typeof window !== 'undefined' && window.cdn) {
          const swatchUrl = `${window.cdn}${handleize(colorValue)}.png`;
          const sized = this.buildSizedImageUrl(swatchUrl, 80);
          return { backgroundImage: `url(${sized})` };
        }
        if (child?.image) {
          const sizedImage = this.buildSizedImageUrl(child.image, 80);
          return { backgroundImage: `url(${sizedImage})` };
        }
        return {};
      },
      getBundleChildSelectedLabel(child) {
        const fullLabel = this.getBundleChildDisplayLabel(child);
        if (!fullLabel) {
          return '';
        }
        const parts = fullLabel.split(':');
        if (parts.length > 1) {
          return `/ ${parts.slice(1).join(':').trim()}`;
        }
        return fullLabel;
      },
      applyBundleVariantMetadata(variant, options = {}) {
        if (!variant) {
          return;
        }
        const { updateColor = false, syncChildSelections = true, skipAddToBag = false } = options;

        this.activeBundleVariantId = variant.variantId || null;
        this.selectedSize = variant.size || '';
        this.selectedWidth = variant.width || '';

        if (syncChildSelections) {
          this.updateBundleChildSelectionsFromVariant(variant);
        }

        if (updateColor) {
          const colorData = this.colors.find(color => color.name === variant.color);
          if (colorData) {
            this.suspendBundleChildSync = true;
            try {
              this.setColorSelection(colorData.name, colorData.images, colorData.media, colorData.tags, colorData.pid, colorData.handle, colorData.description);
            } finally {
              this.suspendBundleChildSync = false;
            }
          } else {
            this.selectedColor = variant.color || '';
            this.isColorSelected = Boolean(this.selectedColor);
            if (!skipAddToBag) {
              this.setAddToBagButton();
            }
          }
          return;
        }

        if (!skipAddToBag) {
          this.setAddToBagButton();
        }
      },
      syncBundleChildrenToColor(colorName) {
        if (!this.isBundleProduct || !colorName) {
          return;
        }
        const variant = this.findBundleVariantByColor(colorName);
        if (!variant) {
          console.warn('No bundle variant found for color', colorName);
          return;
        }
        this.applyBundleVariantMetadata(variant, {
          updateColor: false,
          syncChildSelections: true,
          skipAddToBag: true
        });
      },
      handleBundleChildSelectionChange() {
        if (!this.isBundleProduct) {
          return;
        }
        const nextVariant = this.findBestBundleVariantForSelections(this.bundleChildSelections);
        if (!nextVariant) {
          console.warn('Unable to resolve bundle variant from selections');
          return;
        }
        this.applyBundleVariantMetadata(nextVariant, {
          updateColor: true,
          syncChildSelections: false
        });
      },
      buildInitialBundleChildSelections(children) {
        const selections = {};
        if (!Array.isArray(children)) return selections;
        children.forEach(child => {
          selections[child.key] = {};
          (child.options || []).forEach(option => {
            selections[child.key][option.name] = option.values?.[0] || '';
          });
        });
        return selections;
      },
      isBundleOptionSelected(childKey, optionName, value) {
        return this.bundleChildSelections[childKey] && this.bundleChildSelections[childKey][optionName] === value;
      },
      getBundleOptionClasses(childKey, optionName, value) {
        const isSelected = this.isBundleOptionSelected(childKey, optionName, value);
        const isAvailable = this.isBundleChildOptionAvailable(childKey, optionName, value);
        return {
          selected: isSelected,
          unavailable: !isAvailable,
          'is-disabled': !isAvailable
        };
      },
      selectBundleChildOption(childKey, optionName, value, event) {
        if (event) {
          typeof event.preventDefault === 'function' && event.preventDefault();
          typeof event.stopPropagation === 'function' && event.stopPropagation();
          typeof event.stopImmediatePropagation === 'function' && event.stopImmediatePropagation();
        }
        if (!childKey || !optionName || !value) {
          return;
        }
        if (this.isBundleOptionSelected(childKey, optionName, value)) {
          return;
        }
        this.updateBundleChildSelection(childKey, optionName, value);
        this.handleBundleChildSelectionChange();
      },
      shouldShowBundleOption(option) {
        if (!option || !Array.isArray(option.values)) {
          return false;
        }
        const uniqueValues = option.values.filter((value, index, self) => self.indexOf(value) === index);
        return uniqueValues.length > 1;
      },
      getBundleChildColorLabel(child) {
        if (!child) {
          return '';
        }
        const selections = this.bundleChildSelections[child.key] || {};
        const findColorOption = (options = []) => options.find(option => option?.name && option.name.toLowerCase().includes('color'));

        const colorOption = findColorOption(child.visibleOptions || []) || findColorOption(child.options || []);

        if (colorOption) {
          const value = selections[colorOption.name] || colorOption.values?.[0] || '';
          if (value) {
            return value;
          }
        }

        return child.swatchColor || '';
      },
      getBundleChildTitleMain(child) {
        if (!child) {
          return '';
        }
        const colorLabel = this.getBundleChildColorLabel(child);
        return colorLabel ? `${child.title}: ${colorLabel}` : child.title;
      },
      getBundleChildDisplayLabel(child) {
        const selections = this.bundleChildSelections[child.key] || {};

        const primaryOptions = child.visibleOptions && child.visibleOptions.length ? child.visibleOptions : child.options || [];

        const displayParts = primaryOptions.map(option => selections[option.name] || option.values[0] || '').filter(Boolean);

        if (!displayParts.length && child.options && child.options.length) {
          displayParts.push(child.options[0].values[0] || '');
        }

        return displayParts.length ? `${child.title}: ${displayParts.join(' / ')}` : child.title;
      },
      getBundleChildLink(child) {
        if (!child?.handle) {
          return '#';
        }
        const selections = this.bundleChildSelections[child.key] || {};
        const params = new URLSearchParams();
        (child.options || []).forEach((option, index) => {
          const value = selections[option.name] || option.values[0] || '';
          if (value) {
            params.set(`op${index + 1}`, value);
          }
        });
        const query = params.toString();
        return `/products/${child.handle}${query ? `?${query}` : ''}`;
      },
      applyPendingProductColor() {
        if (!this.pendingProductColor || !this.colors || this.colors.length === 0) return;

        const colorMatch = this.colors.find(c => c.name === this.pendingProductColor);
        if (colorMatch) {
          this.setColorSelection(colorMatch.name, colorMatch.images, colorMatch.media, colorMatch.tags, colorMatch.pid, colorMatch.handle, colorMatch.description);
          this.pendingProductColor = null;
        }
      },
      setColorSelection(color, images, media, tags, pid, handle, description, userInitiated = false) {
        const nextProductID = pid != null && pid !== '' ? String(pid) : '';
        if (!this.sourceProductID && nextProductID) {
          this.sourceProductID = nextProductID;
        }
        if (userInitiated && this.sourceProductID && nextProductID && nextProductID !== String(this.sourceProductID) && nextProductID !== String(this.currentDisplayedProductID)) {
          reportProductSwatchSwitch({ productID: nextProductID, sourceProductID: this.sourceProductID });
        }
        if (nextProductID) {
          this.currentDisplayedProductID = nextProductID;
        }

        this.selectedColor = color;
        this.isColorSelected = true;
        const emittedHandle = this.getDisplayHandle(handle);
        if (this.isBundleProduct && !this.suspendBundleChildSync) {
          this.syncBundleChildrenToColor(color);
        }

        // prettier-ignore
        const colorElements = this.pdpSection.querySelectorAll(
        `.color-variant-options [data-color='${CSS.escape(color)}']`,
      );

        [...this.pdpSection.querySelectorAll('.color-variant-options [data-color]')].forEach(el => {
          el.classList.remove('selected');
        });

        colorElements.forEach(el => {
          el.classList.add('selected');
        });

        emitter.emit('pdp-color-updated', {
          images: images,
          pid: pid,
          media: media
        });

        const favProductId = pid ? String(pid).replace(/\D+/g, '') : '';
        const favHandle = this.getFavoriteHandle(pid, handle);
        if (favProductId && favHandle) {
          syncPdpFavoriteProduct(favProductId, favHandle, this.product_title, !this.mini_pdp, images);
        }

        if (tags) {
          const payload = { tags: tags, pid: pid };
          if (this.isOutfitPicker && Number.isFinite(this.outfitPickerIndex)) payload.blockIndex = this.outfitPickerIndex;
          emitter.emit('pdp-tags-updated', payload);
        }
        this.emitBundleHandleUpdate(emittedHandle);
        this.emitBundleChildHandleUpdate();

        if (this.mini_pdp) {
          const viewFullDetailsLink = this.pdpSection.querySelector('.product-template-link');
          if (viewFullDetailsLink) {
            viewFullDetailsLink.href = `/products/${handle}`;
          }
        }

        const faqColorRow = this.colors.find(c => c.name === color);
        emitter.emit('variant-color-selected', {
          color,
          images,
          media,
          pid,
          handle: emittedHandle,
          description,
          faqsAccordionHtml: faqColorRow?.faqsAccordionHtml
        });
        emitter.emit('start-full-pdp', {
          images,
          media,
          pid,
          tags,
          handle
        });

        const finalizeSelection = () => {
          this.clickSelectedVariants();
          this.setBundleChildOptionWidths();
          this.setAddToBagButton();
          if (this.isBundleProduct) {
            this.emitBundleChildHandleUpdate();
          }
        };

        if ('requestIdleCallback' in window) {
          requestIdleCallback(
            () => {
              finalizeSelection();
            },
            { timeout: 100 }
          );
        } else {
          setTimeout(() => {
            finalizeSelection();
          }, 50);
        }
      },
      sortColorGroupOrder(colors) {
        if (!Array.isArray(colors)) {
          return [];
        }
        const colorGroupOrder = this.normalizeOrderTokens(this.swatchColorGroupOrder);
        if (!this.isBundleProduct) {
          return colors.sort((a, b) => {
            const colorGroupComparison = this.compareByOrder(colorGroupOrder, a?.colorGroupId, b?.colorGroupId);
            if (colorGroupComparison !== 0) {
              return colorGroupComparison;
            }
            return (a?.name || '').localeCompare(b?.name || '');
          });
        }
        const bundleOrder = this.bundleOptionOrder.length ? this.bundleOptionOrder : this.normalizeOrderTokens(typeof window !== 'undefined' ? window.pdp_bundle_order : '');

        return colors.sort((a, b) => {
          const bundleComparison = this.compareByOrder(bundleOrder, a?.name, b?.name);
          if (bundleComparison !== 0) {
            return bundleComparison;
          }
          const colorGroupComparison = this.compareByOrder(colorGroupOrder, a?.colorGroupId, b?.colorGroupId);
          if (colorGroupComparison !== 0) {
            return colorGroupComparison;
          }
          return (a?.name || '').localeCompare(b?.name || '');
        });
      },
      refreshBundleOptionOrder() {
        this.bundleOptionOrder = this.normalizeOrderTokens(typeof window !== 'undefined' ? window.pdp_bundle_order : '');
      },
      normalizeOrderTokens(source) {
        if (!source) {
          return [];
        }
        const tokens = Array.isArray(source) ? source : String(source).split(',');
        return tokens.map(token => (token || '').toString().trim().toLowerCase()).filter(Boolean);
      },
      compareByOrder(order, valueA, valueB) {
        const indexA = this.getOrderIndex(order, valueA);
        const indexB = this.getOrderIndex(order, valueB);
        if (indexA === indexB) {
          return 0;
        }
        return indexA - indexB;
      },
      getOrderIndex(order, rawValue) {
        if (!Array.isArray(order) || !order.length || rawValue == null) {
          return Number.MAX_SAFE_INTEGER;
        }
        const normalizedValue = rawValue.toString().trim().toLowerCase();
        if (!normalizedValue.length) {
          return Number.MAX_SAFE_INTEGER;
        }
        const foundIndex = order.findIndex(item => {
          if (item == null) {
            return false;
          }
          return item.toString().trim().toLowerCase() === normalizedValue;
        });
        return foundIndex === -1 ? Number.MAX_SAFE_INTEGER : foundIndex;
      },
      getFirstBundleChildHandle() {
        if (!Array.isArray(this.bundleChildren) || !this.bundleChildren.length) {
          return '';
        }
        return this.bundleChildren[0]?.handle || '';
      },
      getFavoriteHandle(pid, fallbackHandle) {
        const normalizedId = pid ? String(pid).replace(/\D+/g, '') : '';
        if (this.isBundleProduct && normalizedId) {
          const colorRow = this.colors.find(c => c.name === this.selectedColor) || this.colors.find(c => String(c.pid || '').replace(/\D+/g, '') === normalizedId);
          const match = colorRow?.bundleComponents?.find(c => String(c.productId || '').replace(/\D+/g, '') === normalizedId);
          if (match?.productHandle) {
            return match.productHandle;
          }
        }
        return fallbackHandle || this.product_handle || '';
      },
      getDisplayHandle(fallbackHandle) {
        if (this.isBundleProduct) {
          const childHandle = this.getFirstBundleChildHandle();
          if (childHandle) {
            return childHandle;
          }
        }
        return fallbackHandle || this.product_handle || '';
      },
      emitBundleHandleUpdate(fallbackHandle) {
        const handleToEmit = this.getDisplayHandle(fallbackHandle);
        if (!handleToEmit) {
          return;
        }
        if (handleToEmit === this.lastEmittedHandle) {
          return;
        }
        this.lastEmittedHandle = handleToEmit;
        emitter.emit('pdp-handle-updated', { handle: handleToEmit });
      },
      emitBundleChildHandleUpdate() {
        if (!this.isBundleProduct || !this.bundleChildren?.length) {
          return;
        }
        const childHandle = this.bundleChildren[0]?.handle;
        if (!childHandle) {
          return;
        }
        emitter.emit('bundle-child-handle-updated', { handle: childHandle });
      },
      sortBundleOptionValues(optionName, values) {
        if (!Array.isArray(values) || !values.length) {
          return [];
        }
        const orderTokens = this.getOptionOrderTokens(optionName);
        if (!orderTokens.length) {
          return values.slice().sort((a, b) => a.localeCompare(b));
        }
        return values.slice().sort((a, b) => {
          const indexA = this.getOrderIndex(orderTokens, a);
          const indexB = this.getOrderIndex(orderTokens, b);
          if (indexA === indexB) {
            return a.localeCompare(b);
          }
          return indexA - indexB;
        });
      },
      getOptionOrderTokens(optionName) {
        if (!optionName) {
          return [];
        }
        if (this.isWidthOptionName(optionName)) {
          return this.optionThreeOrderTokens;
        }
        if (this.isSizeOptionName(optionName)) {
          return this.optionTwoOrderTokens;
        }
        return [];
      },
      setBlingLinks() {
        if (this.customBling && this.customBlingElements) {
          this.customBlingElements.forEach(item => {
            if (this.product_handle?.includes(item.toLowerCase())) {
              this.customBlingBase = this.product_handle.replace('juicy-couture-' + item.toLowerCase(), '');
              this.currentBling = item;
            }
          });
        }
      },
      isThisBling(bling) {
        return bling === this.currentBling ? 'selected ' + this.customBling : this.customBling;
      },
      getColorSwatchImages(color) {
        const baseUrl = window.cdn + handleize(color.name) + '.png';
        const sizedUrl = this.buildSizedImageUrl(baseUrl, 120);
        return 'background-image:url(' + sizedUrl + ')';
      },
      getImageSwatchImages(color) {
        let imageName = color.images.find(image => {
          const imgUrl = image?.node?.url;
          return imgUrl?.includes(this.swatch_suffix);
        })?.node?.url;

        if (!imageName && color.images[0]?.node?.url) {
          imageName = color.images[0].node.url;
        }
        return imageName;
      },
      buildSizedImageUrl(url, width) {
        return buildSizedImageUrl(url, width);
      },
      getImageSwatchSrcSet(color) {
        const base = this.getImageSwatchImages(color);
        return buildResponsiveSrcset(base, 60);
      },
      setDefaultSelections() {
        if (!Array.isArray(this.colors) || !this.colors.length) return;

        if (this.isOutfitPicker && this.pendingProductColor) {
          this.applyPendingProductColor();
          return;
        }

        const candidates = [];
        if (this.passedOptOne) candidates.push(this.passedOptOne);
        if (this.previouslySelectedProduct?.color) candidates.push(this.previouslySelectedProduct.color);

        let chosenColorName = candidates.find(n => this.colors.some(c => c.name === n));

        if (!chosenColorName) {
          const matchByHandle = this.colors.find(c => c.handle === this.product_handle);
          if (matchByHandle) chosenColorName = matchByHandle.name;
        }

        if (!chosenColorName) {
          const available = this.colors.find(c => this.variants && this.variants.some(v => v.availableForSale && v.color === c.name));
          if (available) chosenColorName = available.name;
        }

        if (!chosenColorName) {
          chosenColorName = this.colors[0].name;
        }

        const color = this.colors.find(c => c.name === chosenColorName);
        if (color) {
          this.setColorSelection(color.name, color.images, color.media, color.tags, color.pid, color.handle, color.description);
        }
        if (this.isBundleProduct && this.bundleChildren?.length) {
          this.emitBundleChildrenMetaUpdate();
        }
      },
      updateColorAvailabilityForPartialSelection() {
        this.disableAllOptions();
        let color = '';
        let size = '';
        let width = '';
        if (this.isColorSelected) {
          color = isTrimmed(this.selectedColor.toString()) ? this.selectedColor.toString() : this.selectedColor.trim();
        }
        if (this.selectedSize) {
          size = isTrimmed(this.selectedSize.toString()) ? this.selectedSize.toString() : this.selectedSize.trim();
        }
        if (this.selectedWidth) {
          width = isTrimmed(this.selectedWidth.toString()) ? this.selectedWidth.toString() : this.selectedWidth.trim();
        }
        this.variants.forEach(product => {
          if (!product.availableForSale) return;
          if (size && product.size !== size) return;
          if (width && product.width !== width) return;
          this.setEnabled(product.color, size || product.size, width || product.width, product.color === color);
        });
      },
      setAddToBagButton() {
        if (!this.variants || !this.variants.length) return;
        if (this.isOutfitPicker && !this.isColorSelected) {
          return;
        }
        const hasSizeOptions = this.variants.some(v => v.size);
        const hasWidthOptions = this.variants.some(v => v.width);
        if ((hasSizeOptions && !this.selectedSize) || (hasWidthOptions && !this.selectedWidth)) {
          this.updateColorAvailabilityForPartialSelection();
          return;
        }
        this.disableAllOptions();
        let color = '';
        let width = '';
        let size = '';
        let status = true;
        let notavail = false;
        let pid = '';
        let image = '';
        // eslint-disable-next-line
        let productType = '';
        // eslint-disable-next-line
        let availableId = false;
        // eslint-disable-next-line
        let quantityAvailable;
        // eslint-disable-next-line
        let price;
        // eslint-disable-next-line
        let compare;
        // eslint-disable-next-line
        let vid;
        // eslint-disable-next-line
        let upsellProductId;
        let upsellProductId2;
        // eslint-disable-next-line
        let sku;
        let upsellImage;
        let variantMetafields;

        if (this.isColorSelected) {
          color = isTrimmed(this.selectedColor.toString()) ? this.selectedColor.toString() : this.selectedColor.trim();
        }
        if (this.selectedSize) {
          size = isTrimmed(this.selectedSize.toString()) ? this.selectedSize.toString() : this.selectedSize.trim();
        }
        if (this.selectedWidth) {
          width = isTrimmed(this.selectedWidth.toString()) ? this.selectedWidth.toString() : this.selectedWidth.trim();
        }

        let productFound = false;
        const productLoop = this.variants;
        productLoop.forEach(product => {
          if (product.color === color && product.width === width && product.size === size) {
            productFound = true;
            if (product.availableForSale) {
              availableId = product.variantId;
              pid = product.masterId;
              quantityAvailable = product.quantityAvailable;
              vid = product.variantId;
              price = product.price;
              compare = product.compareAtPrice;
              sku = product.sku;
              image = product.image;
              productType = product.productType;
              upsellProductId = product.upsellProductId;
              upsellProductId2 = product.upsellProductId2;
              upsellImage = product.upsellImage;
              variantMetafields = product.variantMetafields;
              this.setEnabled(color, size, width, true);
            } else {
              vid = product.variantId;
              pid = product.masterId;
              price = product.price;
              compare = product.compareAtPrice;
              image = product.image;
              productType = product.productType;
              upsellProductId = product.upsellProductId;
              upsellProductId2 = product.upsellProductId2;
              upsellImage = product.upsellImage;
              variantMetafields = product.variantMetafields;
              this.setDisabled(color);
              status = false;
            }
          } else {
            // check ahead feature
            if (product.color === color && product.width === width) {
              if (product.availableForSale) {
                this.setEnabled(color, product.size, width, false);
              }
            }
            if (product.color === color && product.size === size) {
              if (product.availableForSale) {
                this.setEnabled(color, size, product.width, false);
              }
            }
            if (product.size === size && product.width === width) {
              if (product.availableForSale) {
                this.setEnabled(product.color, size, width, false);
              }
            }
          }
        });

        if (!productFound) {
          status = false;
          notavail = true;
          this.setDisabled(color);
        }

        if (quantityAvailable > 0) {
          status = true;
        }

        this.setElevarTrackingPDP(vid, color, size, width);
        const addButtonPayload = {
          variantId: vid,
          parentId: pid,
          handle: this.product_handle,
          pageHandle: typeof window !== 'undefined' ? window.pdp_product_handle || '' : '',
          variantPrice: price,
          comparePrice: compare,
          instock: status,
          notavail: notavail,
          quantityAvailable: quantityAvailable,
          upsellProductId: upsellProductId,
          upsellProductId2: upsellProductId2,
          enableUpsellOption: this.hasUpsellProduct,
          isOutfitPicker: this.isOutfitPicker,
          isBundleProduct: this.isBundleProduct,
          selectedOptions: [this.selectedColor || null, this.selectedSize || null, this.selectedWidth || null],
          variantMetafields: variantMetafields || null
        };
        if (typeof window !== 'undefined') {
          window.__pdpAddButtonPayload = addButtonPayload;
        }
        emitter.emit('updateAddButton', addButtonPayload);

        this.setProductListOptionLinks();

        setTimeout(() => {
          if (upsellImage) {
            emitter.emit('replace-variant-image', upsellImage);
          } else {
            const previousVariant = this.previousVariant || {};
            const colorChanged = previousVariant.color !== color;
            const widthChanged = previousVariant.width !== width;
            if (colorChanged || widthChanged) {
              emitter.emit('variant-updated', {
                image,
                variantId: vid,
                color: color,
                size: size,
                width: width
              });
            }
            this.previousVariant = { color, size, width };
          }
        }, 200);
      },
      setElevarTrackingPDP(vid, color, size, width) {
        if (typeof vid === 'string') {
          const pd = {
            vid: vid.toString(),
            color: color.toString(),
            size: size.toString(),
            width: width.toString()
          };
          if (window.setPDPProductTrackingDetails) {
            window.setPDPProductTrackingDetails(pd);
          }
        }
      },
      colorOptionAriaLabel(colorName, available) {
        const sizeContext = this.selectedSize ? ` in size ${this.selectedSize}` : '';
        const status = available ? 'available' : 'currently unavailable';
        return `${this.product_title}${sizeContext} color option: ${colorName} is ${status}`;
      },
      disableAllOptions() {
        [...this.pdpSection.querySelectorAll('.color-variant-options [data-color]')].forEach(el => {
          el.classList.add('unavailable');
          el.setAttribute('aria-label', this.colorOptionAriaLabel(el.getAttribute('data-color'), false));
        });
      },
      setEnabled(color, size, width, currentProduct) {
        [...this.pdpSection.querySelectorAll(`[data-color='${color}']`)].forEach(el => {
          if (currentProduct || !el.classList.contains('selected')) {
            el.classList.remove('unavailable');
            el.setAttribute('aria-label', this.colorOptionAriaLabel(el.getAttribute('data-color'), true));
          }
        });
      },
      setDisabled(color) {
        [...this.pdpSection.querySelectorAll(`[data-color='${CSS.escape(color)}']`)].forEach(el => {
          el.classList.add('unavailable');
          el.setAttribute('aria-label', this.colorOptionAriaLabel(color, false));
        });
      },
      setBundleChildOptionWidths() {
        if (this.excludeSwatchWidth || !this.isBundleProduct) {
          return;
        }
        this.pdpSection.querySelectorAll('.bundle-child__option-block .variant-spacing').forEach(container => {
          const buttons = [...container.querySelectorAll('.p-options')];
          if (!buttons.length) return;
          var biggestWidth = 0;
          buttons.forEach(btn => {
            btn.style.width = '';
            var width = btn.offsetWidth;
            if (width > biggestWidth) biggestWidth = width;
          });
          buttons.forEach(btn => {
            btn.style.width = biggestWidth + 'px';
          });
        });
      },
      setProductListOptionLinks() {
        const productListOptionLinks = this.pdpSection.querySelectorAll('.product_list_option_item');
        const miniPdpQuery = this.mini_pdp ? '&view=mini' : '';
        const params = 'op1=' + (this.selectedColor || '') + '&op2=' + (this.selectedSize || '') + '&op3=' + (this.selectedWidth || '') + miniPdpQuery;
        productListOptionLinks.forEach(item => {
          const baseUrl = item.getAttribute('href').split('?')[0];
          item.setAttribute('href', baseUrl + '?' + params);
        });
      },
      clickSelectedVariants() {
        if (this.selectedSize) {
          const sizeEl = this.pdpSection.querySelector(`[data-size='s${CSS.escape(this.selectedSize)}']`);
          if (sizeEl) sizeEl.click();
        }

        if (this.selectedWidth) {
          const widthEl = this.pdpSection.querySelector(`[data-width='w${CSS.escape(this.selectedWidth)}']`);
          if (widthEl) widthEl.click();
        }
      },
      setBlingHref(href) {
        window.location = href + '?op1=' + this.selectedColor + '&op2=' + this.selectedSize + '&op3=' + this.selectedWidth;
      }
    }
  };
</script>

<template>
  <div class="color-variant-options" :class="{ 'is-bundle-mode': isBundleProduct }">
    <div v-if="customBling" class="bling-wrapper">
      <div v-for="(item, index) in customBlingElements" :class="isThisBling(item)" :key="'bling-' + index" @click="setBlingHref('/products/juicy-couture-' + item.toLowerCase() + customBlingBase)">
        <a v-html="item"></a>
      </div>
    </div>

    <template v-if="isBundleProduct">
      <div class="bundle-selector" v-if="bundledProducts.length > 1">
        <p class="bundle-selector__title gt-p__small">
          {{ bundleSelectorLabel }}
        </p>
        <div class="bundle-selector__list">
          <button v-for="(bundleOption, index) in bundledProducts" :key="bundleOption.handle || index" type="button" :class="['bundle-selector__item', { 'is-active': bundleOption.handle === activeBundleHandle }]" :aria-pressed="bundleOption.handle === activeBundleHandle" @click="selectBundle(bundleOption.handle)">
            <span class="bundle-selector__image" :style="getBundleSwatchStyle(bundleOption)">
              <span class="visually-hidden"> {{ bundleSelectorLabel }} {{ index + 1 }} </span>
            </span>
          </button>
        </div>
      </div>

      <div class="bundle-child-list">
        <div class="bundle-child__header" v-for="child in bundleChildren" :key="child.key">
          <div class="bundle-child__title-row">
            <span
              class="bundle-child__swatch"
              :class="{
                'bundle-child__swatch--empty': !hasBundleChildSwatch(child)
              }"
              :style="getBundleChildSwatchStyle(child)"
            >
              <span class="visually-hidden">
                {{ getBundleChildDisplayLabel(child) }}
              </span>
            </span>
            <h4 class="bundle-child__title gt-p__small">
              <a :href="getBundleChildLink(child)">
                <span class="bundle-child__title-main gt-p__small">{{ getBundleChildTitleMain(child) }}</span>
                <span class="bundle-child__title-selected gt-p__small">
                  {{ getBundleChildSelectedLabel(child) }}
                </span>
              </a>
            </h4>
            <button type="button" v-if="shouldShowBundleSizeGuide(child)" :id="bundleSizeGuideAnchorKey === child.key ? 'size-guide-toggle' : null" class="size-guide-toggle gt-p__small bundle-child__size-guide" @click="showSizeGuide()">Size Guide</button>
          </div>
          <div v-for="option in child.visibleOptions" :key="child.key + option.name" class="bundle-child__option-block gt-p__small">
            <p class="option-title gt-p__small">
              <span class="option-name gt-p__small">{{ option.name }}</span>
            </p>
            <div class="variant-spacing variant-spacing-swatch">
              <button v-for="value in option.values" :key="child.key + option.name + value" type="button" class="option p-options option2" :class="getBundleOptionClasses(child.key, option.name, value)" @click.stop.prevent="selectBundleChildOption(child.key, option.name, value, $event)">
                {{ value }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <p v-if="colors.length && cleanColorName(selectedColor) !== 'Default Title'" :class="'option-title color-title' + (mini_pdp ? ' mini-pdp-option-title' : '')">
        <span v-html="optionOneName" class="option-name gt-p__small"></span>
        <span class="gt-p__small">:&nbsp;</span>
        <span v-html="cleanColorName(selectedColor)" class="gt-p__small"></span>
      </p>

      <!-- Non-price-grouped swatches -->
      <template v-if="this.enablePriceGrouping === 'false' && !isOutfitPicker">
        <!-- Color swatches -->
        <div class="variant-spacing variant-spacing-swatch" v-if="swatchRenderingConfig.shouldShowSwatches">
          <div v-for="(color, index) in colors" :key="'color' + index">
            <div :class="color.name">
              <a v-if="swatchRenderingConfig.showColorSwatches" :class="isExcludedColorOption(color.productType)" :data-color="color.name" :data-coming-soon="isComingSoonColor(color)" :style="getColorSwatchImages(color)" @click="setColorSelection(color.name, color.images, color.media, color.tags, color.pid, color.handle, color.description, true)" @touchstart="setColorSelection(color.name, color.images, color.media, color.tags, color.pid, color.handle, color.description, true)" v-html="color.name" tabindex="0"></a>

              <!-- Image swatches -->
              <a v-else-if="swatchRenderingConfig.showImageSwatches" :class="getImageSwatchClass()" :data-coming-soon="isComingSoonColor(color)" :data-color="color.name" @click="setColorSelection(color.name, color.images, color.media, color.tags, color.pid, color.handle, color.description, true)" @touchstart="setColorSelection(color.name, color.images, color.media, color.tags, color.pid, color.handle, color.description, true)" tabindex="0">
                <img :src="buildSizedImageUrl(getImageSwatchImages(color), 60)" :srcset="getImageSwatchSrcSet(color)" sizes="50px" :alt="`${product_title} color option: ${color.name}`" style="width: 100%" :loading="enableLazyLoading ? 'lazy' : 'eager'" />
                <span v-html="color.name" class="visually-hidden"></span>
              </a>
            </div>
          </div>
        </div>
      </template>

      <!-- Price-grouped swatches -->
      <template v-if="this.enablePriceGrouping === 'true' && !isOutfitPicker">
        <template v-for="(priceGroup, index) in priceGroups" :key="'price-group' + index">
          <template v-if="priceGroups.length > 1 && hasVisibleSwatchesForPriceGroup(priceGroup)">
            <PDPPriceGroupBlock :currentPriceNumber="priceGroup" :comparePriceNumber="priceGroupsCompareList[priceGroup]" :showPercentage="showPercentageOff" :showOriginalOnSalePrice="showOriginalOnSalePrice"></PDPPriceGroupBlock>
          </template>

          <div class="variant-spacing variant-spacing-swatch" v-if="shouldShowSwatches() && hasVisibleSwatchesForPriceGroup(priceGroup)">
            <!-- Color swatches -->
            <template v-for="(color, colorIndex) in colors" :key="'color-' + priceGroup + '-' + colorIndex">
              <template v-if="colorPriceGroupMap && colorPriceGroupMap.get(color.name) === priceGroup">
                <a v-if="!swatch_suffix || isCurrentExcludedColorOption()" :class="isExcludedColorOption(color.productType)" :data-color="color.name" :data-coming-soon="isComingSoonColor(color)" :style="getColorSwatchImages(color)" @click="setColorSelection(color.name, color.images, color.media, color.tags, color.pid, color.handle, color.description, true)" v-html="color.name" tabindex="0"></a>

                <!-- Image swatches -->
                <a v-else-if="swatch_suffix && !isCurrentExcludedColorOption()" :class="getImageSwatchClass()" :data-color="color.name" :data-coming-soon="isComingSoonColor(color)" @click="setColorSelection(color.name, color.images, color.media, color.tags, color.pid, color.handle, color.description, true)" tabindex="0">
                  <img :src="buildSizedImageUrl(getImageSwatchImages(color), 60)" :srcset="getImageSwatchSrcSet(color)" sizes="50px" :alt="`${product_title} color option: ${color.name}`" style="width: 100%" :loading="enableLazyLoading ? 'lazy' : 'eager'" />
                  <span v-html="color.colorGroupId.replace('color-', '')" class="visually-hidden"></span>
                  <span v-html="color.name" class="visually-hidden"></span>
                </a>
              </template>
            </template>
          </div>
        </template>
      </template>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  .color-variant-options {
    .variant-spacing {
      display: flex;
      flex-wrap: wrap;
      row-gap: 5px;
    }

    &.is-bundle-mode {
      .option-title {
        display: none;
      }
    }

    .bling-wrapper {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 24px;
      align-items: stretch;
      flex-direction: row;

      div {
        min-width: 95px;
        text-align: center;
        border: 1px solid #ccc;
        margin-right: 9px;
        margin-bottom: 6px;
        border-radius: 4px;
        flex: 1;
        padding-top: 5px;
        padding-bottom: 5px;
        cursor: pointer;

        &.bridal {
          @media (max-width: 1450px) {
            flex-basis: 45%;
          }
        }

        a {
          color: #000;
        }

        &.selected {
          border: 1px solid #000;

          a {
            color: #000;
          }
        }
      }
    }

    .bundle-selector {
      margin-bottom: 16px;
      padding-bottom: 16px;
      border-bottom: 1px solid #f0f0f0;

      &__title {
        margin-bottom: 8px;
        font-weight: 600;
      }

      &__list {
        display: flex;
        flex-wrap: wrap;
        gap: var(--bundle-selector-gap, 8px);
      }

      &__item {
        display: inline-flex;
        align-items: center;
        border: var(--bundle-selector-border-width, 1px) solid var(--bundle-selector-border-color, #d4d4d4);
        border-radius: var(--bundle-selector-radius, 4px);
        background: var(--bundle-selector-bg, #fff);
        box-shadow: 0 0 0 var(--bundle-selector-outline-width, 1px) var(--bundle-selector-outline-color, #d4d4d4);
        padding: 4px;
        cursor: pointer;
        font-size: 14px;
        transition:
          border-color 0.2s ease,
          box-shadow 0.2s ease;

        &.is-active {
          border-color: var(--bundle-selector-border-color-selected, #101820);
          background: var(--bundle-selector-bg-selected, #fff);
          box-shadow: 0 0 0 var(--bundle-selector-outline-width, 1px) var(--bundle-selector-outline-color-selected, #101820);
        }
      }

      &__image {
        width: var(--bundle-selector-swatch-width, 48px);
        height: var(--bundle-selector-swatch-height, 48px);
        border-radius: var(--bundle-selector-radius, 4px);
        overflow: hidden;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      }
    }

    .bundle-child-list {
      border: none;
      border-radius: 0;
      padding: 0;
    }

    .bundle-child__header {
      margin-bottom: 24px;

      .bundle-child__title-row {
        display: flex;
        align-items: center;
        gap: var(--bundle-title-row-gap, 12px);
        margin-bottom: 8px;
        margin-right: 0;
        flex-wrap: wrap;

        .bundle-child__size-guide {
          margin-left: auto;
          align-self: center;
          flex: 0 0 auto;
          cursor: pointer;
        }
      }

      .bundle-child__title {
        margin-bottom: 0;
        font-weight: 600;
        min-width: 0;
        max-width: calc(100% - 120px);

        a {
          color: inherit;
          text-decoration: none;
          overflow-wrap: anywhere;
          word-break: break-word;

          &:hover,
          &:focus {
            text-decoration: underline;
          }

          .bundle-child__title-main {
            text-decoration: underline;
          }

          .bundle-child__title-selected {
            text-decoration: none;
            margin-left: 4px;
            color: inherit;
          }
        }
      }

      .bundle-child__option-block {
        margin-bottom: 12px;

        .option-title {
          margin-bottom: 4px;
        }
      }
    }
  }
</style>
